import { Outlet } from "react-router-dom";
import Header from "./Header/HeaderMain";
import Footer from "./Footer/Footer";

const Body = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Body;
